/**
 * Shared spacing scale used across all layout components.
 *
 * Components import named steps (`xxs` through `xl5`) from `spacings` rather
 * than using raw numbers so that spacing stays consistent and can be adjusted
 * centrally.
 */

import { defaultTheme } from '@repo/theme';

/** @public */
export type Spacing = keyof typeof spacings;

export const spacings = defaultTheme.spacing;
